export const projects = [
  {
    title: "Tiny Pesa",
    subtitle: "Nuxt/Vue and Python",
    description:
      "Tiny Pesa is a payment processing platform that allows users to utilise M-pesas STK Push API as well as integrate bank payments.",
    image: "./tinyafrica.png",
    link: "https://tinypesa.com",
  },
  {
    title: "PnP Radius",
    subtitle: "Nuxt/Vue and Django",
    description: "An experimental react firebase project up and coming",
    image: "./pnpradius.png",
    link: "https://pnpradius.com",
  },
  // {
  //   title: "Epic Todo App",
  //   subtitle: "React Hooks",
  //   description: "A simple todo react project",
  //   image: "./project-4.gif",
  //   link: "#",
  // },
  {
    title: "Breaking Bad Api",
    subtitle: "React and Tailwind Css",
    description:
      "A web app showcasing the characters of the popular tv series the breaking bad",
    image: "./walterwhite.gif",
    link: "https://the-breaking-bad-api-v1.netlify.app/",
  },
];

export const testimonials = [
  {
    quote:
      "Did a very good job in developing an API based covid-19 tracker for my project. Was fast in coming with the results.",
    image: "https://randomuser.me/api/portraits/men/16.jpg",
    name: "Marvin",
    company: "Student",
  },
  {
    quote:
      "I like how Martin is dedicated to his work.Deployed a really nice and fast application that helped our company interact with our customers alot better.",
    image: "https://randomuser.me/api/portraits/men/25.jpg",
    name: "Watson",
    company: "Property Merchants",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "Python",
  "Django",
  "Flask",
  "Material UI",
  "Vue", 
  "Nuxt",
  "Docker",
  "Sql",
  "MongoDb",
  "FaunaDb"
];



// WEBPACK FOOTER //
// ./src/data.js